import { AddCandidatesFromJobBoardsComponent } from "./add-candidates-from-job-boards.component";
import { JobBoardsSupportedParametersModule } from "./jobBoardsSupportedParameters/job-boards-supported-parameters.module";
export const AddCandidatesFromJobBoardsModule = angular
    .module('addCandidatesFromJobBoards', [JobBoardsSupportedParametersModule])
    .component(AddCandidatesFromJobBoardsComponent.selector, AddCandidatesFromJobBoardsComponent.component)
    .name;
//# sourceMappingURL=add-candidates-from-job-boards.module.js.map